import { render } from "./governance_lock_section.html?vue&type=template&id=0f3c9ad8&external"
import script from "./governance_lock_section.js?vue&type=script&lang=js&external"
export * from "./governance_lock_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__